<div class="container max-view-height">
    <div class="row justify-content-between">
        <app-breadcrumb [crumbs]="crumbs" class="col"></app-breadcrumb>
        @if (Features.PlatformsSave | hasFeature) {
            <button aria-label="Edit platform" mat-icon-button routerLink="/{{Routenames.platforms}}/{{platform().id}}">
                <mat-icon fontIcon="fa-edit" fontSet="fas"></mat-icon>
            </button>
        }
    </div>
    <div>
        <h3>
            <b>{{platform().name}}</b>
        </h3>
    </div>

    <table class="table table-hover table-last-col table-add-row">
        <thead>
            <tr>
                <th>Naam</th>
                <th>URL</th>
                <th>Level</th>
                <th class="w-0">Status</th>
                <th>Laatste check</th>
                <th>SSL vervaldatum</th>
                <th>Opschorting tot</th>
                <th>Probleem</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            @for (checkpoint of sortedCheckpoints(); track checkpoint.id) {
                <tr>
                    <td>
                        <a class="text-dark" routerLink="/{{Routenames.seire}}/{{platform().id}}/overview/{{checkpoint.id}}">
                            {{checkpoint.name}}
                        </a>
                    </td>
                    <td>
                        <div class="d-flex gap-2">
                            <a href="{{checkpoint.url}}" target="_blank">
                                {{checkpoint.url | urlPrefixStripping}}
                            </a>
                            <a class="text-dark" href="{{checkpoint.url}}" target="_blank">
                                <mat-icon class="align-bottom pt-1" fontIcon="fa-up-right-from-square" fontSet="fas"></mat-icon>
                            </a>
                        </div>
                    </td>
                    <td>{{checkpoint.level}}</td>
                    <td class="pb-0 pt-1">
                        <div class="d-flex justify-content-center">
                            <div [class]="checkpoint.level | CheckpointLevelStatusPipe: checkpoint"></div>
                        </div>
                    </td>
                    <td class="text-nowrap">{{checkpoint.updated_at | lastCheckReadable}}</td>
                    <td [class]="checkpoint?.ssl_valid_till | sslValidUntil" class="text-end">{{(checkpoint?.ssl_valid_till | daysFromNow) ?? '-'}}</td>
                    <td class="text-end">{{(checkpoint?.postponed_till | date:'EEE d MMM yyyy HH:mm') ?? '-'}}</td>
                    <td>{{checkpoint?.checkpoint_result_last_instance?.result}}</td>
                    <td class="py-0 w-0">
                        @if (Features.CheckpointsSave | hasFeature) {
                            <button aria-label="Edit checkpoint" color="primary" mat-icon-button routerLink="/{{Routenames.seire}}/{{platform().id}}/store/{{checkpoint.id}}">
                                <mat-icon fontIcon="fa-edit" fontSet="fas"></mat-icon>
                            </button>
                        }
                    </td>
                </tr>
            } @empty {
                <tr>
                    <td class="text-center" colspan="99">
                        @if (checkpoints() === null) {
                            Aan het laden...
                        } @else {
                            Geen checkpoints gevonden
                        }
                    </td>
                </tr>
            }
            @if (Features.CheckpointsSave | hasFeature) {
                <tr>
                    <td colspan="99">
                        <button class="w-100 btn btn-secondary" routerLink="/{{Routenames.seire}}/{{platform().id}}/store/new">
                            Add Checkpoint <i class="fas fa-plus"></i>
                        </button>
                    </td>
                </tr>
            }
        </tbody>
    </table>
</div>

<div class="fixed-bottom w-100">
    <div class="container">
        <table class="table table-hover table-last-col table-add-row">
            <thead>
                <tr>
                    <th>Level</th>
                    <th class="text-end">Server IP</th>
                    <th>Server name</th>
                    <th class="text-end">Apache</th>
                    <th>Apache module</th>
                    <th class="text-end">Apache php</th>
                    <th class="text-end">Os</th>
                    <th class="text-end">Php</th>
                    <th class="text-end">Mysql</th>
                    <th class="text-end">Updates</th>
                    <th class="text-end">Last updated</th>
                </tr>
            </thead>
            <tbody>
                @for (server of servers(); track server.name) {
                    @if (server.server) {
                        <tr>
                            <td>{{server.name}}</td>
                            <td class="text-end">{{server.server.ip}}</td>
                            <td>{{server.server.server_name}}</td>
                            <td class="text-end">{{server.server.apache}}</td>
                            <td>{{server.server.apache_module}}</td>
                            <td class="text-end">{{server.server.apache_php}}</td>
                            <td class="text-end">{{server.server.os}}</td>
                            <td class="text-end">{{server.server.php}}</td>
                            <td class="text-end">{{server.server.mysql}}</td>
                            <td class="text-end">{{server.server.updates}}</td>
                            <td [class.text-danger]="isOlderThan2Days(server.server.updated_at)" class="text-end">{{server.server.updated_at | date:'EEE d MMM HH:mm'}}</td>
                        </tr>
                    }
                } @empty {
                    <tr>
                        <td colspan="99">Geen servers beschikbaar</td>
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>
